import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	onlyVisibleToYou: {
		id: 'issue-smart-request-summary.header.only-visible-to-you',
		defaultMessage: 'Only visible to you',
		description:
			'Heading text shown on smart request summary panel to indicate that it is not published anywhere',
	},
	close: {
		id: 'issue-smart-request-summary.header.close',
		defaultMessage: 'Close comment summary',
		description: 'Label text for button that closes the summary panel',
	},
});
